import { EventEmitter, Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { ApiCollectionResponse, Tag, User } from '../app/app.interfaces';

@Injectable()
export class TagService {

  public initialized: EventEmitter<void> = new EventEmitter();
  public isInitialized: boolean = false;
  public tags: Tag[] = null;

  public activeTag: Tag = null;

  constructor(private apiService: ApiService) {
    this.loadTags();
  }

  public getAllTags(): Promise<Tag[]> {
    return new Promise<Tag[]>((resolve) => {
      this.afterInit().then(() => {
        resolve(this.tags);
      })
    });
  }

  public loadTags(): void {
    this.apiService.getCollection('tags').then((apiResponse: ApiCollectionResponse) => {
      this.tags = apiResponse.items;
      this.isInitialized = true;
      this.initialized.emit();
    }).catch((err) => {
      console.error(err);
    });
  }

  public setActiveTag(tag: Tag){
    if(tag) {
      let currentActive = this.tags.find(tag => tag.active);
      if (currentActive) currentActive.active = false;

      tag.active = true;
      this.activeTag = tag;
    }
  }

  public setActiveTagById(tagId: Number): Promise<Tag> {

    return new Promise((resolve, reject) => {
      this.afterInit().then(() => {
        let newActiveTag = this.findById(tagId);
        if(!newActiveTag) {
          reject();
        }
        else {
          this.setActiveTag(newActiveTag);
          resolve(newActiveTag);
        }

      });
    });
  }

  public addTag(title: string) {
    this.tags.push({title: title});
  }

  public static makePlain(tags: Tag[]): Tag[] {
     return tags.map((tag) => {
       return { title: tag.title };
     });
  }

  public findById(tagId: Number): Tag {
    if(!this.isInitialized) return null;
    return this.tags.find(tag => tag.id === tagId);
  }

  public searchByTitle(title: string): Promise<Tag[]> {

    return new Promise<Tag[]>((resolve) => {
      const regex = new RegExp(title,"i");

      this.afterInit().then(() => {
        const foundTags = this.tags.filter(tag => {
          return tag.title.search(regex) !== -1;
        });
        resolve(foundTags);
      })

    });

  }

  public findByIdAsync(tagId: Number): Promise<Tag> {
    return new Promise<Tag>((resolve) => {
      this.afterInit().then(() => {
        resolve(this.tags.find(tag => tag.id === tagId));
      });
    });
  }


  private afterInit(): Promise<void> {
    return new Promise((resolve) => {
      if (this.isInitialized) {
        resolve();
      }
      else {
        this.initialized.subscribe(() => {
          resolve();
        });
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/services/tag.service.ts